import React, { useState, useEffect } from 'react';
import '../css/newtheme.css';
import { GetRelatedPost } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const RelatedPost = (postSlugObject) => {
  const [relatedPost, setRelatedPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleBlogClick = () => navigate('/blog/:paramlink');

  const fillRelatedPost = async () => {
    try {
      const relatedPostList = await GetRelatedPost(postSlugObject.postSlug);
      const jsonPostList = JSON.parse(relatedPostList);
      setRelatedPost(jsonPostList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fillRelatedPost();
  }, [postSlugObject.postSlug]);

  return (
    <div class="blog-details-right-area blog-right-sidebar" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
      <div class="blog-widget archives-widget" data-aos="fade-up"
        data-aos-duration="1600">
        <h3 class="title">Related Post</h3>
        <ul>
          {
            loading ? <Loader /> :
              relatedPost?.map((item) => (
                <li>
                  <a href={"/blog/" + item.paramlink} onClick={handleBlogClick}> {item.title} </a>
                </li>
              ))
          }
        </ul>
      </div>
    </div>
  );
};

export default RelatedPost;